// ============================================================
//  src/components/layout/ProtectedRoute.jsx
// ============================================================
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import LoadingScreen from '../ui/LoadingScreen';

export default function ProtectedRoute({ children, role }) {
  const { isAdminLoggedIn, isVoterLoggedIn, loading } = useAuth();
  const location = useLocation();

  if (loading) return <LoadingScreen />;

  if (role === 'admin' && !isAdminLoggedIn) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }
  if (role === 'voter' && !isVoterLoggedIn) {
    return <Navigate to="/voter/login" replace />;
  }
  return children;
}
